var _circle, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.5,
    stroke: "#EBECF0",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1_4991",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 -1.22392e-06C31.677 -1.38465e-06 35.318 0.724242 38.7151 2.13137C42.1122 3.5385 45.1989 5.60097 47.799 8.20101C50.399 10.801 52.4615 13.8877 53.8686 17.2849C55.2758 20.682 56 24.323 56 28L53.2 28C53.2 24.6907 52.5482 21.4138 51.2818 18.3564C50.0153 15.299 48.1591 12.5209 45.8191 10.1809C43.4791 7.84087 40.701 5.98466 37.6436 4.71824C34.5862 3.45182 31.3093 2.8 28 2.8L28 -1.22392e-06Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 -1.22392e-06C31.677 -1.38465e-06 35.318 0.724242 38.7151 2.13137C42.1122 3.5385 45.1989 5.60097 47.799 8.20101C50.399 10.801 52.4615 13.8877 53.8686 17.2849C55.2758 20.682 56 24.323 56 28L53.2 28C53.2 24.6907 52.5482 21.4138 51.2818 18.3564C50.0153 15.299 48.1591 12.5209 45.8191 10.1809C43.4791 7.84087 40.701 5.98466 37.6436 4.71824C34.5862 3.45182 31.3093 2.8 28 2.8L28 -1.22392e-06Z",
    stroke: "#C9C9C9",
    strokeWidth: 6,
    mask: "url(#path-2-inside-1_1_4991)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.836ac95712449b424ab481efdb1cc4d0.svg";
export { ForwardRef as ReactComponent };